import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames";
import { CustomInput } from "Components/ReactstrapSlim";
import { Module, ModuleCaption } from "Components/Module";
import { AccountClient, MemberNotificationModel } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import UserContext from "../../UserContext";

export interface NotificationInformationProps {
}

export const NotificationInformation: React.FC<NotificationInformationProps> = ({ }) => {   
   const accountClient = useApiClient(AccountClient);
   const user = useContext(UserContext);

   const [isLoading, setIsLoading] = useState<boolean>(true);
   const [settings, setSettings] = useState<MemberNotificationModel[]>([]);   

   const onChange = async (setting: MemberNotificationModel) => {      
      try {         
         var newSetting = {...setting, enabled: !setting.enabled} as MemberNotificationModel;         
         setSettings((settings) => [...settings.filter(s => s.type != setting.type), newSetting])
         let result = await accountClient.setNotificationValue(newSetting.type, newSetting.enabled);
      } catch (err: any) {
         console.log(err);
      }
   }
  
   const getNotificationSettings = async (abortSignal: AbortSignal) => {
      setIsLoading(true);
      try {
         setSettings(await accountClient.notificationList(abortSignal));
      } catch (err: any) {
         console.log(err);
      }
      setIsLoading(false);
   }

   useEffect(() => {
      const abortController = new AbortController();
      getNotificationSettings(abortController.signal);
      return function cleanup() {
         abortController.abort();
      }
   }, []);

   return (
      <Module size="lg" loading={isLoading} className={classNames("module-notification-information")}>
         <ModuleCaption className="mb-px16">
            Email Subscriptions and Notifications
         </ModuleCaption>
         <div className="notification-information-wrapper">
            {settings.sort((a, b) => a.order - b.order).map((s) => 
               (<div className="notification-option-wrapper" key={s.type}>
                  <div>
                     <label className="checkbox-wrapper ">
                        <CustomInput type="checkbox" id={s.type} onChange={() => onChange(s)} defaultValue={`${s.enabled}`} checked={s.enabled} />
                     </label>
                  </div>
                  <div className="p1">
                     <div>
                        <span className="label">
                           {s.description}
                        </span>
                     </div>
                     <div className="lbl1">{s.subDescription}</div>
                  </div>
               </div>
            ))}
         </div>
      </Module>
   );
}